import { Box, Button, CircularProgress, Container, Grid, IconButton, Modal, Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TablePagination, TableRow } from '@mui/material';
import React, { Component } from 'react'
import Constantes from '../php/Constantes';
import ReactHtmlTableToExcel from 'react-html-table-to-excel';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Redirect } from 'react-router-dom';

const StyledTableCell = styled (TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
}));
  
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F4F6F6',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const handleDownloadPdf = (name, data) => {
    const blobData = atob(data);
    const byteArray = new Uint8Array(blobData.length);
    for (let i = 0; i < blobData.length; i++) {
      byteArray[i] = blobData.charCodeAt(i);
    }
    const fileBlob = new Blob([byteArray], { type: 'application/pdf' });
    const fileUrl = URL.createObjectURL(fileBlob);

    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

let aux = '';
let desc = '';
let filasTotales = 0;
let entradaIn = '';
let salidaIn = '';
const opcionesFilasPorPagina = [5, 10, 25];

class ConsultasControlAsistenciaUsuario extends Component {
    constructor(props){
        super(props);
        this.state = {
            //------------------
            pagina: 0,
            filasPorPagina: 5,
            //------------------
            notificaciones: null,
            errores: null,
            consulta: false,
            consultaRealizada: [],
            atras: false,
            mesActual: false,
            loading: false,
            consultaEspecifica: false,
            datoEspecifico: {},
            tieneSolLt: false,
            tieneSolSAH: false,
            tieneSolDia: false,

            busqueda:{
                codigo: 1001,
                mes: '',
                anio: '',
                numeroFuncionario: sessionStorage.numeroFuncionario,
                numeroFuncionarioBusqueda: sessionStorage.numeroFuncionario,
                nombreFuncionarioBusqueda: sessionStorage.nombreFuncionario,
                ubicacionBusqueda: '',
                ubicacionCentral: '',
            },
            isFieldsetOpen: true,
            isFieldsetOpenSolicitudes: false,
            nuevaSolicitud: false,
            informesAListar: [],
            codigosInforme: [],
            hayDatos: false,
            codigosEstadosInforme: [],
            modalConsulta: false,
            datoEspecificoConsulta: {},
            horasEntradas: [],
            ubicacionesCentral: [],
            lugaresTra: [],
            compensarLlegadaTarde: false,
            compensarSAH: false,
            datosAEnviar: {
                numeroFuncionario: '',
                codigo: '',
                nombreFuncionario: '',
                ubicacionBusqueda: '',
                ubicacionCentral: '',
                desde: '',
                hasta: '',
                anio: '',
                dias: '',
                marca1: '',
                marca2: '',
                minutos: '',
                tipoMov: '2',
                familiar: '',
                archivo: '',
                archivoFamiliar: '',
                juzgado: '',
                entrada: '',
                salida: '',
                entrada2: '',
                salida2: '',
                salidaAntHoraDesde: '',
                salidaAntHoraHasta: '',
                concepto: '',
                tipo: '',
                entradaLunes: '',
                entradaMartes: '',
                entradaMiercoles: '',
                entradaJueves: '',
                entradaViernes: '',
                entradaSabado: '',
                salidaLunes: '',
                salidaMartes: '',
                salidaMiercoles: '',
                salidaJueves: '',
                salidaViernes: '',
                salidaSabado: '',
                comentarios: '',
            },

            hoveredCell: null,
            compensarDia: false,
        }
        this.manejarCambiosDatos = this.manejarCambiosDatos.bind(this);
        this.manejoEnvioConsulta = this.manejoEnvioConsulta.bind(this);
        this.manejarAtras = this.manejarAtras.bind(this);
        this.manejarAtrasPagina = this.manejarAtrasPagina.bind(this);
        this.toggleFieldset = this.toggleFieldset.bind(this);
        this.handleDateClick = this.handleDateClick.bind(this);
        this.manejarNuevaSolicitud = this.manejarNuevaSolicitud.bind(this);
        this.manejarAtrasEspecifico = this.manejarAtrasEspecifico.bind(this);
        this.manejarConsulta = this.manejarConsulta.bind(this);
        this.cerrarModal = this.cerrarModal.bind(this);
        this.compensar = this.compensar.bind(this);
        this.manejarCambioAEnviar = this.manejarCambioAEnviar.bind(this);
        this.manejarEnvioInforme = this.manejarEnvioInforme.bind(this);
    }

    async componentDidMount(){
        const codInfo = await fetch(`${Constantes.RUTA_API}/obtener_codigosMovimientos.php`);
        const datosCodInfo = await codInfo.json();
        this.setState({
            codigosInforme: datosCodInfo,
        });

        const codEstadoInfo = await fetch(`${Constantes.RUTA_API}/obtener_codigosEstadosInforme.php`);
        const datosCodEstadoInfo = await codEstadoInfo.json();
        this.setState({
            codigosEstadosInforme: datosCodEstadoInfo,
        });

        const lugar = await fetch(`${Constantes.RUTA_API}/obtener_lugaresTrabajo.php`);
        const datoLugar = await lugar.json();
        this.setState({
            lugaresTra: datoLugar,
        });


        const lugarCentral = await fetch(`${Constantes.RUTA_API}/obtener_ubicacionesCentral.php`);
        const datoLugarCentral = await lugarCentral.json();
        this.setState({
            ubicacionesCentral: datoLugarCentral,
        });

        const ent = await fetch(`${Constantes.RUTA_API}/obtener_entradas.php`);
        const datosEntrada = await ent.json();
        this.setState({
            horasEntradas: datosEntrada,
        });
    }

    toggleFieldsetSolicitudes = () => {
        this.setState(prevState => ({
            isFieldsetOpenSolicitudes: !prevState.isFieldsetOpenSolicitudes
        }));
    };

    handleChangePage = (event, nuevaPagina) => {
        this.setState({ pagina: nuevaPagina });
    };
    
    handleChangeRowsPerPage = (event) => {
        const filasPorPagina = event.target.value === 'all' ? this.state.informesAListar.length : parseInt(event.target.value, 10);
        this.setState({ filasPorPagina, pagina: 0 });
    };

    //-------------------
    handleMouseEnter = (index) => {
        this.setState({ hoveredCell: index });
      };
    
      handleMouseLeave = () => {
        this.setState({ hoveredCell: null });
      };
    //-------------------

    render(){
        const { isFieldsetOpen } = this.state;
        const { isFieldsetOpenSolicitudes } = this.state;
        const { pagina, filasPorPagina } = this.state;
        filasTotales = this.state.informesAListar.length;
        const { hoveredCell } = this.state;
        
        return (
            <>
                {sessionStorage.login
                ?
                    <Container>
                        <h3>Control de Asistencia</h3>
                        {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                        {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                        {this.state.loading
                        ?
                            <div style={{placeItems: 'center'}}>
                                <Box sx={{alignItems: 'center'}}>
                                    <CircularProgress/>
                                </Box>
                            </div>
                        :
                            null
                        }
                        <br/>
                        
                            {this.state.consulta && (!this.state.consultaEspecifica)
                            ?
                                <Container>
                                    {this.state.mesActual
                                    ?
                                        <h5 style={{color: 'red'}}>Mes sin confirmar</h5>
                                    :
                                        null
                                    }
                                    <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper} >
                                        <Table sx={{minWidth: 700}} id="tablaConsulta">
                                            <TableHead>
                                                <TableRow>
                                                    <StyledTableCell align="center" colSpan={10}>
                                                        TARJETA:  {this.state.consultaRealizada[0].numeroFuncionario} {this.state.consultaRealizada[0].nombreFuncionario}
                                                    </StyledTableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableHead>
                                                <TableRow>
                                                    <StyledTableCell>Día</StyledTableCell>
                                                    <StyledTableCell>Fecha</StyledTableCell>
                                                    <StyledTableCell>Entra</StyledTableCell>
                                                    <StyledTableCell>Sale</StyledTableCell>
                                                    <StyledTableCell>Entra</StyledTableCell>
                                                    <StyledTableCell>Sale</StyledTableCell>
                                                    <StyledTableCell>Entra</StyledTableCell>
                                                    <StyledTableCell>Sale</StyledTableCell>
                                                    <StyledTableCell>Observaciones</StyledTableCell>
                                                    <StyledTableCell>Ubicación</StyledTableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {this.state.consultaRealizada.map((dato, index) => (
                                                    dato.resumen !== '' ?
                                                        <TableRow key={index}>
                                                            <StyledTableCell colSpan={10}>{dato.resumen}</StyledTableCell>
                                                        </TableRow>
                                                    :
                                                        <StyledTableRow key={index}>
                                                            <StyledTableCell width={'20%'}>{dato.diaSemana}</StyledTableCell>
                                                            <StyledTableCell width={'20%'} className="clickable" onClick={() => this.handleDateClick(dato)} onMouseEnter={() => this.handleMouseEnter(index)} onMouseLeave={this.handleMouseLeave} style={{backgroundColor: hoveredCell === index ? '#fae1e1' : 'transparent', cursor: 'pointer',}}>{dato.fecha}</StyledTableCell>
                                                            <StyledTableCell width={'20%'}>{dato.marca1}</StyledTableCell>
                                                            <StyledTableCell width={'20%'}>{dato.marca2}</StyledTableCell>
                                                            <StyledTableCell width={'20%'}>{dato.marca3}</StyledTableCell>
                                                            <StyledTableCell width={'20%'}>{dato.marca4}</StyledTableCell>
                                                            <StyledTableCell width={'20%'}>{dato.marca5}</StyledTableCell>
                                                            <StyledTableCell width={'20%'}>{dato.marca6}</StyledTableCell>
                                                            <StyledTableCell width={'20%'}>{dato.observaciones}</StyledTableCell>
                                                            <StyledTableCell width={'20%'}>{dato.ubicacion}</StyledTableCell>
                                                        </StyledTableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Container>
                            :
                                !this.state.consultaEspecifica
                                ?
                                    <form onSubmit={this.manejoEnvioConsulta}>
                                        <Box sx={{ flexGrow: 1}} >
                                            <Grid container spacing={2} rowSpacing={1}>
                                                <Grid item xs={2.5}>
                                                
                                                </Grid>
                                                <Grid item xs={2.5}>
                                                        <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='mes'  value={this.state.busqueda.mes} onChange={this.manejarCambiosDatos}>
                                                            <option value=''>MES</option>
                                                            <option value={'01'}>ENERO</option>
                                                            <option value={'02'}>FEBRERO</option>
                                                            <option value={'03'}>MARZO</option>
                                                            <option value={'04'}>ABRIL</option>
                                                            <option value={'05'}>MAYO</option>
                                                            <option value={'06'}>JUNIO</option>
                                                            <option value={'07'}>JULIO</option>
                                                            <option value={'08'}>AGOSTO</option>
                                                            <option value={'09'}>SETIEMBRE</option>
                                                            <option value={'10'}>OCTUBRE</option>
                                                            <option value={'11'}>NOVIEMBRE</option>
                                                            <option value={'12'}>DICIEMBRE</option>
                                                        </select>
                                                </Grid>
                                                <Grid item xs={2}>
                                                    <input style={{width:"100%", border:"2px solid #D6EAF8"}} placeholder='Año (YYYY)' type="number" id='anio' value={this.state.busqueda.anio} onChange={this.manejarCambiosDatos}/>
                                                </Grid>
                                                <Grid item xs={1.5}>
                                                    <button className="btn btn-outline-primary" type='submit'>Consultar</button>
                                                </Grid>
                                            </Grid>
                                        </Box>
                                    </form>
                                :
                                    null
                            }
                            {this.state.consulta && (!this.state.consultaEspecifica)
                            ?
                                <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarAtras}>Volver</button>
                            :
                                (!this.state.consultaEspecifica)
                                ?
                                    <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarAtrasPagina}>Volver</button>
                                :
                                    null
                            }
                            {this.state.atras
                            ?
                                <Redirect to='/Consultas'/>
                            :
                                null
                            }
                            {this.state.consultaEspecifica
                            ?
                                <>
                                    <h3>RESUMEN DÍA: {this.state.datoEspecifico.fecha}</h3>
                                    {this.state.datoEspecifico.marca1} {this.state.datoEspecifico.marca2} {this.state.datoEspecifico.marca3} {this.state.datoEspecifico.marca4} {this.state.datoEspecifico.marca5} {this.state.datoEspecifico.marca6}<br/>
                                    {/*this.state.datoEspecifico.observaciones*/}
                                    {this.state.datoEspecifico.minutosTardes > 0
                                    ?
                                        <>
                                            <p>Tiene {this.state.datoEspecifico.minutosTardes} minutos de llegada tarde</p> {this.state.tieneSolLt || (!this.state.mesActual) ? null : <p style={{color: 'green'}} className="clickable" onClick={() => this.compensar(this.state.datoEspecifico, 1)}>Compensar</p>}
                                        </>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.minutosSalidaAntes > 0
                                    ?
                                        <>
                                            <p>Tiene {this.state.datoEspecifico.minutosSalidaAntes} minutos de salida antes de hora</p> {this.state.tieneSolSAH || (!this.state.mesActual) ? null : <p style={{color: 'green'}} className="clickable" onClick={() => this.compensar(this.state.datoEspecifico, 2)}>Compensar</p>}
                                        </>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.marca1 === ''
                                    ?
                                        <>
                                            {(this.state.tieneSolDia) || (!this.state.mesActual) ? null : <p style={{color: 'green'}} className="clickable" onClick={() => this.compensar(this.state.datoEspecifico, 0)}>Compensar Día</p>}
                                        </>
                                    :
                                        null
                                    }
                                    {/*this.state.mesActual ? <button className="btn btn-outline-primary mx-2" type='button' onClick={this.manejarNuevaSolicitud}>Nueva Solicitud</button> : null*/}
                                    {this.state.nuevaSolicitud
                                    ?
                                        <>
                                        </>
                                    :
                                        null
                                    }
                                    {this.state.compensarLlegadaTarde
                                    ?
                                        <TableContainer style={{width: '75%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                                            <Table sx={{minWidth: 700}} id="tablaConsulta">
                                                <TableHead>
                                                    <TableRow>
                                                        <StyledTableCell style={{textAlign: 'center'}}>Concepto</StyledTableCell>
                                                        <StyledTableCell style={{textAlign: 'center'}}>Tipo</StyledTableCell>
                                                        {this.state.datosAEnviar.codigo === '40' ? <StyledTableCell style={{textAlign: 'center'}}>Días</StyledTableCell> : <StyledTableCell style={{textAlign: 'center'}}>Minutos</StyledTableCell>}
                                                        <StyledTableCell></StyledTableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    <StyledTableRow>
                                                        <StyledTableCell>
                                                            <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='codigo'  value={this.state.datosAEnviar.codigo} onChange={this.manejarCambioAEnviar}>
                                                                <option value=''></option>
                                                                <option value={46}>HORAS SIMPLES</option>
                                                                <option value={28}>HORAS INHÁBILES</option>
                                                                {this.state.datosAEnviar.tipo === 0 ? <option value={40}>ACTA 1694</option> : null}
                                                            </select>
                                                        </StyledTableCell>
                                                        {this.state.datosAEnviar.tipo === 0 ? <StyledTableCell style={{textAlign: 'center'}}>DIA COMPLETO</StyledTableCell> : null}
                                                        {this.state.datosAEnviar.tipo === 1 ? <StyledTableCell style={{textAlign: 'center'}}>LLEGADA TARDE</StyledTableCell> : null}
                                                        {this.state.datosAEnviar.tipo === 2 ? <StyledTableCell style={{textAlign: 'center'}}>SALIDA ANTES DE HORA</StyledTableCell> : null}
                                                        {this.state.datosAEnviar.codigo === '40' ? <StyledTableCell style={{textAlign: 'center'}}><input style={{border: "2px solid #D6EAF8", width: "100%"}} id='dias' value={this.state.datosAEnviar.dias} onChange={this.manejarCambioAEnviar} type="number" /></StyledTableCell> : <StyledTableCell style={{textAlign: 'center'}}><input style={{border: "2px solid #D6EAF8", width: "100%"}} id='minutos' value={this.state.datosAEnviar.minutos} onChange={this.manejarCambioAEnviar} type="number" /></StyledTableCell>}
                                                        <StyledTableCell style={{textAlign: 'center'}}><button className="btn btn-outline-primary mx-2" type='button' onClick={this.manejarEnvioInforme}>Enviar</button></StyledTableCell>
                                                    </StyledTableRow>
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    :
                                        null
                                    }
                                    {!this.state.modalConsulta
                                    ?
                                        <fieldset>
                                            <legend onClick={this.toggleFieldset} className="clickable">
                                                {/*isFieldsetOpen ? 'Ocultar Información' : 'Mostrar Información'*/}
                                            </legend>
                                            {isFieldsetOpen && (
                                                <div className="fieldset-content">
                                                    {this.state.hayDatos
                                                    ?
                                                        <Container>
                                                            <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                                                                <Table sx={{minWidth: 700}} id="tablaConsulta">
                                                                    <TableHead>
                                                                        <TableRow>
                                                                            <StyledTableCell>Informe</StyledTableCell>
                                                                            <StyledTableCell>Número</StyledTableCell>
                                                                            <StyledTableCell>Nombre</StyledTableCell>
                                                                            <StyledTableCell>Estado</StyledTableCell>
                                                                            <StyledTableCell>Desde</StyledTableCell>
                                                                            <StyledTableCell>Hasta</StyledTableCell>
                                                                            <StyledTableCell></StyledTableCell>
                                                                            <StyledTableCell></StyledTableCell>
                                                                        </TableRow>
                                                                    </TableHead>
                                                                    <TableBody>
                                                                        {this.state.informesAListar.slice(this.state.pagina * this.state.filasPorPagina, this.state.pagina * this.state.filasPorPagina + this.state.filasPorPagina).map((name) => (
                                                                            <StyledTableRow key={name.idInformes}>
                                                                                {this.state.codigosInforme.map((name2) => {
                                                                                    if(name2.idCodigoMovimiento === name.codigo){
                                                                                        desc = name2.descripcion;
                                                                                    }
                                                                                })}
                                                                                <StyledTableCell>{desc}</StyledTableCell>
                                                                                <StyledTableCell>{name.numeroFuncionario}</StyledTableCell>
                                                                                <StyledTableCell>{name.nombreFuncionario}</StyledTableCell>
                                                                                {desc = ''}
                                                                                {this.state.codigosEstadosInforme.map((name3) => {
                                                                                    if(name3.idCodigosEstadoInformes === name.finalizado){
                                                                                        desc = name3.descripcion;
                                                                                    }
                                                                                })}
                                                                                <StyledTableCell>{desc}</StyledTableCell>
                                                                                <StyledTableCell>{name.desde.substring(8,10) + '/' + name.desde.substring(5,7) + '/' + name.desde.substring(0,4)}</StyledTableCell>
                                                                                {name.hasta === null ? <StyledTableCell></StyledTableCell> : <StyledTableCell>{name.hasta.substring(8,10) + '/' + name.hasta.substring(5,7) + '/' + name.hasta.substring(0,4)}</StyledTableCell>}
                                                                                <StyledTableCell><button className="btn btn-outline-danger mx-2" type='button' onClick={() => this.manejarConsulta(name)}>Consultar</button></StyledTableCell>
                                                                                <StyledTableCell></StyledTableCell>
                                                                            </StyledTableRow>
                                                                        ))
                                                                        }
                                                                    </TableBody>
                                                                </Table>
                                                            </TableContainer>
                                                            <TablePagination rowsPerPageOptions={opcionesFilasPorPagina} component="div" count={filasTotales} rowsPerPage={this.state.filasPorPagina} page={this.state.pagina} onPageChange={this.handleChangePage} onRowsPerPageChange={this.handleChangeRowsPerPage} labelRowsPerPage="Filas por página" SelectProps={{inputProps: {'aria-label': 'Filas por página',}, displayEmpty: true,}}/>
                                                        </Container>
                                                    :
                                                        <p>No hay datos para mostrar!</p>
                                                    }
                                                </div>
                                            )}
                                            <button className="btn btn-outline-primary mx-2" type='button' onClick={this.manejarAtrasEspecifico}>Volver</button>
                                        </fieldset>
                                    :
                                        <>
                                            {this.state.modalConsulta
                                            ?
                                                <Container>
                                                    <h3>Informes</h3>
                                                    <Box sx={{ flexGrow: 1}}>
                                                        <Grid container spacing={2} rowSpacing={1}>
                                                            {this.state.codigosInforme.map((name2) => {
                                                                if(name2.idCodigoMovimiento === this.state.datoEspecificoConsulta.codigo){
                                                                    desc = name2.descripcion;
                                                                }
                                                            })}
                                                            <Grid item xs={4}>
                                                            </Grid>
                                                            <Grid item xs={4}>
                                                                {desc}
                                                            </Grid>
                                                            <Grid item xs={4}>
                                                            </Grid>
                                                            {/*Esto va siempre */}
                                                            <Grid item xs={2}>
                                                            </Grid>
                                                            {this.state.datoEspecificoConsulta.codigo === 3 || this.state.datoEspecificoConsulta.codigo === 4 || this.state.datoEspecificoConsulta.codigo === 42 || this.state.datoEspecificoConsulta.codigo === 43 || this.state.datoEspecificoConsulta.codigo === 37 || this.state.datoEspecificoConsulta.codigo === 19 || this.state.datoEspecificoConsulta.codigo === 21 || this.state.datoEspecificoConsulta.codigo === 44 || this.state.datoEspecificoConsulta.codigo === 51 || this.state.datoEspecificoConsulta.codigo === 22 || this.state.datoEspecificoConsulta.codigo === 23 || this.state.datoEspecificoConsulta.codigo === 11 || this.state.datoEspecificoConsulta.codigo === 12 || this.state.datoEspecificoConsulta.codigo === 13 || this.state.datoEspecificoConsulta.codigo === 35 || this.state.datoEspecificoConsulta.codigo === 47 || this.state.datoEspecificoConsulta.codigo === 48 || this.state.datoEspecificoConsulta.codigo === 56 || this.state.datoEspecificoConsulta.codigo === 66
                                                            ?
                                                                <Grid item xs={2}>
                                                                    <Item>Certificado (Imagen)</Item>
                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo === 10
                                                            ?
                                                                <Grid item xs={2}>
                                                                    <Item>Constancia de Domicilio</Item>
                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo === 75
                                                            ?
                                                                <Grid item xs={2}>
                                                                    <Item>Comprobante (Imagen)</Item>
                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo === 3 || this.state.datoEspecificoConsulta.codigo === 22 || this.state.datoEspecificoConsulta.codigo === 51 || this.state.datoEspecificoConsulta.codigo === 10 || this.state.datoEspecificoConsulta.codigo === 19 || this.state.datoEspecificoConsulta.codigo === 23 || this.state.datoEspecificoConsulta.codigo === 48 || this.state.datoEspecificoConsulta.codigo === 43 || this.state.datoEspecificoConsulta.codigo === 4 || this.state.datoEspecificoConsulta.codigo === 42 || this.state.datoEspecificoConsulta.codigo === 12 || this.state.datoEspecificoConsulta.codigo === 13 || this.state.datoEspecificoConsulta.codigo === 11 || this.state.datoEspecificoConsulta.codigo === 47 || this.state.datoEspecificoConsulta.codigo === 35 || this.state.datoEspecificoConsulta.codigo === 56 || this.state.datoEspecificoConsulta.codigo === 37 || this.state.datoEspecificoConsulta.codigo === 66 || this.state.datoEspecificoConsulta.codigo === 21
                                                            ?
                                                                this.state.datoEspecificoConsulta.esPDF
                                                                ?
                                                                    <Grid item xs={2}>
                                                                        <button className="btn btn-outline-primary mx-2" onClick={() => handleDownloadPdf('archivo.pdf', this.state.datoEspecificoConsulta.archivoBPS)}>Descargar</button>
                                                                    </Grid>
                                                                :
                                                                    <Grid item xs={2}>
                                                                        <button className="btn btn-outline-danger mx-2" type='button' onClick={() => this.manejarModalImagen(this.state.datoEspecificoConsulta.archivoBPS)}>Ver</button>
                                                                    </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo === 4 || this.state.datoEspecificoConsulta.codigo === 42 || this.state.datoEspecificoConsulta.codigo === 43 || this.state.datoEspecificoConsulta.codigo === 37 || this.state.datoEspecificoConsulta.codigo === 19 || this.state.datoEspecificoConsulta.codigo === 10 || this.state.datoEspecificoConsulta.codigo === 21 || this.state.datoEspecificoConsulta.codigo === 44 || this.state.datoEspecificoConsulta.codigo === 51 || this.state.datoEspecificoConsulta.codigo === 22 || this.state.datoEspecificoConsulta.codigo === 23 || this.state.datoEspecificoConsulta.codigo === 11 || this.state.datoEspecificoConsulta.codigo === 12 || this.state.datoEspecificoConsulta.codigo === 13 || this.state.datoEspecificoConsulta.codigo === 35 || this.state.datoEspecificoConsulta.codigo === 47 || this.state.datoEspecificoConsulta.codigo === 48 || this.state.datoEspecificoConsulta.codigo === 56 || this.state.datoEspecificoConsulta.codigo === 66
                                                            ?
                                                                <Grid item xs={1}>

                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo === 75
                                                            ?
                                                                this.state.datoEspecificoConsulta.esPDF
                                                                ?
                                                                    <Grid item xs={2}>
                                                                        <button className="btn btn-outline-primary mx-2" onClick={() => handleDownloadPdf('archivo.pdf', this.state.datoEspecificoConsulta.archivoBPS)}>Descargar</button>
                                                                    </Grid>
                                                                :
                                                                    <Grid item xs={2}>
                                                                        <button className="btn btn-outline-danger mx-2" type='button' onClick={() => this.manejarModalImagen(this.state.datoEspecificoConsulta.archivoBPS)}>Ver</button>
                                                                    </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo === 11 || this.state.datoEspecificoConsulta.codigo === 12 || this.state.datoEspecificoConsulta.codigo === 13
                                                            ?
                                                                <Grid item xs={2}>
                                                                    <Item>Certificado De Parentesco (Imagen)</Item>
                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo === 12 || this.state.datoEspecificoConsulta.codigo === 13 || this.state.datoEspecificoConsulta.codigo === 11
                                                            ?
                                                                this.state.datoEspecificoConsulta.esPDF
                                                                ?
                                                                    <Grid item xs={2}>
                                                                        <button className="btn btn-outline-primary mx-2" onClick={() => handleDownloadPdf('archivo.pdf', this.state.datoEspecificoConsulta.archivoActa)}>Descargar</button>
                                                                    </Grid>
                                                                :
                                                                    <Grid item xs={2}>
                                                                        <button className="btn btn-outline-danger mx-2" type='button' onClick={() => this.manejarModalImagen(this.state.datoEspecificoConsulta.archivoActa)}>Ver</button>
                                                                    </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo === 11 || this.state.datoEspecificoConsulta.codigo === 12 || this.state.datoEspecificoConsulta.codigo === 13
                                                            ?
                                                                <Grid item xs={1}>

                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo === 11 || this.state.datoEspecificoConsulta.codigo === 12 || this.state.datoEspecificoConsulta.codigo === 13
                                                            ?
                                                                <Grid item xs={2}>
                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo === 4 || this.state.datoEspecificoConsulta.codigo === 42 || this.state.datoEspecificoConsulta.codigo === 11 || this.state.datoEspecificoConsulta.codigo === 12 || this.state.datoEspecificoConsulta.codigo === 13
                                                            ?
                                                                <Grid item xs={2}>
                                                                    <Item>Familiar</Item>
                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo === 11 || this.state.datoEspecificoConsulta.codigo === 42 || this.state.datoEspecificoConsulta.codigo === 12 || this.state.datoEspecificoConsulta.codigo === 13 || this.state.datoEspecificoConsulta.codigo === 4
                                                            ?
                                                                <Grid item xs={2}>
                                                                    {this.state.datoEspecificoConsulta.familiar}
                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo === 4 || this.state.datoEspecificoConsulta.codigo === 42 || this.state.datoEspecificoConsulta.codigo === 11 || this.state.datoEspecificoConsulta.codigo === 12 || this.state.datoEspecificoConsulta.codigo === 13
                                                            ?
                                                                <Grid item xs={1}>

                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo === 4|| this.state.datoEspecificoConsulta.codigo === 42
                                                            ?
                                                                <Grid item xs={2}>

                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo !== 110 && this.state.datoEspecificoConsulta.codigo !== 74 && this.state.datoEspecificoConsulta.codigo !== 75 && this.state.datoEspecificoConsulta.codigo !== 60
                                                            ?
                                                                <Grid item xs={2}>
                                                                    <Item>{this.state.datoEspecificoConsulta.codigo === 43 || this.state.datoEspecificoConsulta.codigo === 19 || this.state.datoEspecificoConsulta.codigo === 10 || this.state.datoEspecificoConsulta.codigo === 21 || this.state.datoEspecificoConsulta.codigo === 106 || this.state.datoEspecificoConsulta.codigo === 109 || this.state.datoEspecificoConsulta.codigo === 37 || this.state.datoEspecificoConsulta.codigo === 110 || this.state.datoEspecificoConsulta.codigo === 62 || this.state.datoEspecificoConsulta.codigo === 30 || this.state.datoEspecificoConsulta.codigo === 53 ? 'Día' : 'Desde'}</Item>
                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo !== 110 && this.state.datoEspecificoConsulta.codigo !== 60 && this.state.datoEspecificoConsulta.codigo !== 61 && this.state.datoEspecificoConsulta.codigo !== 74 && this.state.datoEspecificoConsulta.codigo !== 75
                                                            ?
                                                                <Grid item xs={2}>
                                                                    {String(this.state.datoEspecificoConsulta.desde).substring(8,10) + '/' + String(this.state.datoEspecificoConsulta.desde).substring(5,7) + '/' + String(this.state.datoEspecificoConsulta.desde).substring(0,4)}
                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo === 61
                                                            ?
                                                                <Grid item xs={2}>
                                                                    {this.state.datoEspecificoConsulta.marca1}
                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo !== 110 && this.state.datoEspecificoConsulta.codigo !== 60 && this.state.datoEspecificoConsulta.codigo !== 30
                                                            ?
                                                                <Grid item xs={1}>

                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo === 35 || this.state.datoEspecificoConsulta.codigo === 37 || this.state.datoEspecificoConsulta.codigo === 56
                                                            ?
                                                                <Grid item xs={2}>

                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo === 3 || this.state.datoEspecificoConsulta.codigo === 22 || this.state.datoEspecificoConsulta.codigo === 51 || this.state.datoEspecificoConsulta.codigo === 23 || this.state.datoEspecificoConsulta.codigo === 48 || this.state.datoEspecificoConsulta.codigo === 11 || this.state.datoEspecificoConsulta.codigo === 47 || this.state.datoEspecificoConsulta.codigo === 66 || this.state.datoEspecificoConsulta.codigo === 12 || this.state.datoEspecificoConsulta.codigo === 13
                                                            ?
                                                                <Grid item xs={2}>
                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo !== 53 && this.state.datoEspecificoConsulta.codigo !== 30 && this.state.datoEspecificoConsulta.codigo !== 60 && this.state.datoEspecificoConsulta.codigo !== 75 && this.state.datoEspecificoConsulta.codigo !== 62 && this.state.datoEspecificoConsulta.codigo !== 74 && this.state.datoEspecificoConsulta.codigo !== 43 && this.state.datoEspecificoConsulta.codigo !== 19 && this.state.datoEspecificoConsulta.codigo !== 10 && this.state.datoEspecificoConsulta.codigo !== 21 && this.state.datoEspecificoConsulta.codigo !== 106 && this.state.datoEspecificoConsulta.codigo !== 109 && this.state.datoEspecificoConsulta.codigo !== 110 && this.state.datoEspecificoConsulta.codigo !== 37
                                                            ?
                                                                <Grid item xs={2}>
                                                                    <Item>Hasta</Item>
                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo !== 53 && this.state.datoEspecificoConsulta.codigo !== 30 && this.state.datoEspecificoConsulta.codigo !== 75 && this.state.datoEspecificoConsulta.codigo !== 60 && this.state.datoEspecificoConsulta.codigo !== 62 && this.state.datoEspecificoConsulta.codigo !== 74 && this.state.datoEspecificoConsulta.codigo !== 61 && this.state.datoEspecificoConsulta.codigo !== 43 && this.state.datoEspecificoConsulta.codigo !== 19 && this.state.datoEspecificoConsulta.codigo !== 10 && this.state.datoEspecificoConsulta.codigo !== 21 && this.state.datoEspecificoConsulta.codigo !== 106 && this.state.datoEspecificoConsulta.codigo !== 109 && this.state.datoEspecificoConsulta.codigo !== 110 && this.state.datoEspecificoConsulta.codigo !== 37
                                                            ?
                                                                <Grid item xs={2}>
                                                                    {String(this.state.datoEspecificoConsulta.hasta).substring(8,10) + '/' + String(this.state.datoEspecificoConsulta.hasta).substring(5,7) + '/' + String(this.state.datoEspecificoConsulta.hasta).substring(0,4)}
                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo === 61
                                                            ?
                                                                <Grid item xs={2}>
                                                                    {this.state.datoEspecificoConsulta.marca2}
                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo !== 53 && this.state.datoEspecificoConsulta.codigo !== 30 && this.state.datoEspecificoConsulta.codigo !== 60 && this.state.datoEspecificoConsulta.codigo !== 3 && this.state.datoEspecificoConsulta.codigo !== 62 && this.state.datoEspecificoConsulta.codigo !== 43 && this.state.datoEspecificoConsulta.codigo !== 19 && this.state.datoEspecificoConsulta.codigo !== 10 && this.state.datoEspecificoConsulta.codigo !== 21 && this.state.datoEspecificoConsulta.codigo !== 106 && this.state.datoEspecificoConsulta.codigo !== 109 && this.state.datoEspecificoConsulta.codigo !== 110 && this.state.datoEspecificoConsulta.codigo !== 37
                                                            ?
                                                                <Grid item xs={1}>

                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo === 61
                                                            ?
                                                                <Grid item xs={2}>
                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo === 61 || this.state.datoEspecificoConsulta.codigo === 60
                                                            ?
                                                                <Grid item xs={2}>
                                                                    <Item>Día</Item>
                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo === 61 || this.state.datoEspecificoConsulta.codigo === 60
                                                            ?
                                                                <Grid item xs={2}>
                                                                    {String(this.state.datoEspecificoConsulta.desde).substring(8,10) + '/' + String(this.state.datoEspecificoConsulta.desde).substring(5,7) + '/' + String(this.state.datoEspecificoConsulta.desde).substring(0,4)}
                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo === 80 || this.state.datoEspecificoConsulta.codigo === 71 || this.state.datoEspecificoConsulta.codigo === 1 || this.state.datoEspecificoConsulta.codigo === 67 || this.state.datoEspecificoConsulta.codigo === 40 || this.state.datoEspecificoConsulta.codigo === 16 || this.state.datoEspecificoConsulta.codigo === 17 || this.state.datoEspecificoConsulta.codigo === 29 || this.state.datoEspecificoConsulta.codigo === 5 || this.state.datoEspecificoConsulta.codigo === 52 || this.state.datoEspecificoConsulta.codigo === 14 || this.state.datoEspecificoConsulta.codigo === 15 || this.state.datoEspecificoConsulta.codigo === 20
                                                            ?
                                                                <Grid item xs={2}>
                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo !== 53 && this.state.datoEspecificoConsulta.codigo !== 30 && this.state.datoEspecificoConsulta.codigo !== 60 && this.state.datoEspecificoConsulta.codigo !== 75 && this.state.datoEspecificoConsulta.codigo !== 62 && this.state.datoEspecificoConsulta.codigo !== 74 && this.state.datoEspecificoConsulta.codigo !== 61 && this.state.datoEspecificoConsulta.codigo !== 4 && this.state.datoEspecificoConsulta.codigo !== 46 && this.state.datoEspecificoConsulta.codigo !== 28 && this.state.datoEspecificoConsulta.codigo !== 42 && this.state.datoEspecificoConsulta.codigo !== 43 && this.state.datoEspecificoConsulta.codigo !== 19 && this.state.datoEspecificoConsulta.codigo !== 10 && this.state.datoEspecificoConsulta.codigo !== 21 && this.state.datoEspecificoConsulta.codigo !== 44 && this.state.datoEspecificoConsulta.codigo !== 11 && this.state.datoEspecificoConsulta.codigo !== 12 && this.state.datoEspecificoConsulta.codigo !== 13 && this.state.datoEspecificoConsulta.codigo !== 106 && this.state.datoEspecificoConsulta.codigo !== 109 && this.state.datoEspecificoConsulta.codigo !== 110 && this.state.datoEspecificoConsulta.codigo !== 47 && this.state.datoEspecificoConsulta.codigo !== 66
                                                            ?    
                                                                <Grid item xs={2}>
                                                                    <Item>Días</Item>
                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo !== 53 && this.state.datoEspecificoConsulta.codigo !== 30 && this.state.datoEspecificoConsulta.codigo !== 60 && this.state.datoEspecificoConsulta.codigo !== 75 && this.state.datoEspecificoConsulta.codigo !== 62 && this.state.datoEspecificoConsulta.codigo !== 74 && this.state.datoEspecificoConsulta.codigo !== 61 && this.state.datoEspecificoConsulta.codigo !== 4 && this.state.datoEspecificoConsulta.codigo !== 46 && this.state.datoEspecificoConsulta.codigo !== 28 && this.state.datoEspecificoConsulta.codigo !== 42 && this.state.datoEspecificoConsulta.codigo !== 43 && this.state.datoEspecificoConsulta.codigo !== 19 && this.state.datoEspecificoConsulta.codigo !== 10 && this.state.datoEspecificoConsulta.codigo !== 21 && this.state.datoEspecificoConsulta.codigo !== 44 && this.state.datoEspecificoConsulta.codigo !== 11 && this.state.datoEspecificoConsulta.codigo !== 12 && this.state.datoEspecificoConsulta.codigo !== 13 && this.state.datoEspecificoConsulta.codigo !== 106 && this.state.datoEspecificoConsulta.codigo !== 109 && this.state.datoEspecificoConsulta.codigo !== 110 && this.state.datoEspecificoConsulta.codigo !== 47 && this.state.datoEspecificoConsulta.codigo !== 66
                                                            ?  
                                                                <Grid item xs={2}>
                                                                    {this.state.datoEspecificoConsulta.dias}
                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {(this.state.datoEspecificoConsulta.codigo === 80) || (this.state.datoEspecificoConsulta.codigo === 71) || (this.state.datoEspecificoConsulta.codigo === 1) || (this.state.datoEspecificoConsulta.codigo === 67) || (this.state.datoEspecificoConsulta.codigo === 2) || (this.state.datoEspecificoConsulta.codigo === 37) || (this.state.datoEspecificoConsulta.codigo === 40) || (this.state.datoEspecificoConsulta.codigo === 35) || (this.state.datoEspecificoConsulta.codigo === 56) || (this.state.datoEspecificoConsulta.codigo === 14) || (this.state.datoEspecificoConsulta.codigo === 15) || (this.state.datoEspecificoConsulta.codigo === 16) || (this.state.datoEspecificoConsulta.codigo === 17) || (this.state.datoEspecificoConsulta.codigo === 20)
                                                            ?  
                                                                <Grid item xs={1}>
                                                                    
                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.horasEntradas.map((name) => {
                                                                if(this.state.datoEspecificoConsulta.entrada === name.idEntrada){
                                                                    entradaIn = name.descripcion;
                                                            }})}
                                                            {this.state.horasEntradas.map((name) => {
                                                                if(this.state.datoEspecificoConsulta.salida === name.idEntrada){
                                                                    salidaIn = name.descripcion;
                                                            }})}
                                                            {this.state.datoEspecificoConsulta.codigo === 71
                                                            ?
                                                                <Grid item xs={2}>
                                                                    <Item>Entrada</Item>
                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo === 71
                                                            ?
                                                                <Grid item xs={2}>
                                                                    {entradaIn}
                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo === 71
                                                            ?
                                                                <Grid item xs={1}>
                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo === 71
                                                            ?
                                                                <Grid item xs={2}>
                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo === 71
                                                            ?
                                                                <Grid item xs={2}>
                                                                    <Item>Salida</Item>
                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo === 71
                                                            ?
                                                                <Grid item xs={2}>
                                                                    {salidaIn}
                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo === 71
                                                            ?
                                                                <Grid item xs={1}>
                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo !== 53 && this.state.datoEspecificoConsulta.codigo !== 30 && this.state.datoEspecificoConsulta.codigo !== 60 && this.state.datoEspecificoConsulta.codigo !== 3 && this.state.datoEspecificoConsulta.codigo !== 75 && this.state.datoEspecificoConsulta.codigo !== 62 && this.state.datoEspecificoConsulta.codigo !== 74 && this.state.datoEspecificoConsulta.codigo !== 71 && this.state.datoEspecificoConsulta.codigo !== 61 && this.state.datoEspecificoConsulta.codigo !== 14 && this.state.datoEspecificoConsulta.codigo !== 16 && this.state.datoEspecificoConsulta.codigo !== 17 && this.state.datoEspecificoConsulta.codigo !== 15 && this.state.datoEspecificoConsulta.codigo !== 4 && this.state.datoEspecificoConsulta.codigo !== 29 && this.state.datoEspecificoConsulta.codigo !== 46 && this.state.datoEspecificoConsulta.codigo !== 28 && this.state.datoEspecificoConsulta.codigo !== 42 && this.state.datoEspecificoConsulta.codigo !== 43 && this.state.datoEspecificoConsulta.codigo !== 37 && this.state.datoEspecificoConsulta.codigo !== 19 && this.state.datoEspecificoConsulta.codigo !== 10 && this.state.datoEspecificoConsulta.codigo !== 21 && this.state.datoEspecificoConsulta.codigo !== 44 && this.state.datoEspecificoConsulta.codigo !== 51 && this.state.datoEspecificoConsulta.codigo !== 22 && this.state.datoEspecificoConsulta.codigo !== 23 && this.state.datoEspecificoConsulta.codigo !== 20 && this.state.datoEspecificoConsulta.codigo !== 57 && this.state.datoEspecificoConsulta.codigo !== 11 && this.state.datoEspecificoConsulta.codigo !== 12 && this.state.datoEspecificoConsulta.codigo !== 13 && this.state.datoEspecificoConsulta.codigo !== 35 && this.state.datoEspecificoConsulta.codigo !== 106 && this.state.datoEspecificoConsulta.codigo !== 107 && this.state.datoEspecificoConsulta.codigo !== 109 && this.state.datoEspecificoConsulta.codigo !== 108 && this.state.datoEspecificoConsulta.codigo !== 5 && this.state.datoEspecificoConsulta.codigo !== 52 && this.state.datoEspecificoConsulta.codigo !== 110 && this.state.datoEspecificoConsulta.codigo !== 47 && this.state.datoEspecificoConsulta.codigo !== 48 && this.state.datoEspecificoConsulta.codigo !== 56 && this.state.datoEspecificoConsulta.codigo !== 66
                                                            ?    
                                                                <Grid item xs={2}>
                                                                    <Item>Ejercicio (AÑO)</Item>
                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo !== 53 && this.state.datoEspecificoConsulta.codigo !== 30 && this.state.datoEspecificoConsulta.codigo !== 60 && this.state.datoEspecificoConsulta.codigo !== 3 && this.state.datoEspecificoConsulta.codigo !== 75 && this.state.datoEspecificoConsulta.codigo !== 62 && this.state.datoEspecificoConsulta.codigo !== 74 && this.state.datoEspecificoConsulta.codigo !== 71 && this.state.datoEspecificoConsulta.codigo !== 61 && this.state.datoEspecificoConsulta.codigo !== 14 && this.state.datoEspecificoConsulta.codigo !== 16 && this.state.datoEspecificoConsulta.codigo !== 17 && this.state.datoEspecificoConsulta.codigo !== 15 && this.state.datoEspecificoConsulta.codigo !== 4 && this.state.datoEspecificoConsulta.codigo !== 29 && this.state.datoEspecificoConsulta.codigo !== 46 && this.state.datoEspecificoConsulta.codigo !== 28 && this.state.datoEspecificoConsulta.codigo !== 42 && this.state.datoEspecificoConsulta.codigo !== 43 && this.state.datoEspecificoConsulta.codigo !== 37 && this.state.datoEspecificoConsulta.codigo !== 19 && this.state.datoEspecificoConsulta.codigo !== 10 && this.state.datoEspecificoConsulta.codigo !== 21 && this.state.datoEspecificoConsulta.codigo !== 44 && this.state.datoEspecificoConsulta.codigo !== 51 && this.state.datoEspecificoConsulta.codigo !== 22 && this.state.datoEspecificoConsulta.codigo !== 23 && this.state.datoEspecificoConsulta.codigo !== 20 && this.state.datoEspecificoConsulta.codigo !== 57 && this.state.datoEspecificoConsulta.codigo !== 11 && this.state.datoEspecificoConsulta.codigo !== 12 && this.state.datoEspecificoConsulta.codigo !== 13 && this.state.datoEspecificoConsulta.codigo !== 35 && this.state.datoEspecificoConsulta.codigo !== 106 && this.state.datoEspecificoConsulta.codigo !== 107 && this.state.datoEspecificoConsulta.codigo !== 109 && this.state.datoEspecificoConsulta.codigo !== 108 && this.state.datoEspecificoConsulta.codigo !== 5 && this.state.datoEspecificoConsulta.codigo !== 52 && this.state.datoEspecificoConsulta.codigo !== 110 && this.state.datoEspecificoConsulta.codigo !== 47 && this.state.datoEspecificoConsulta.codigo !== 48 && this.state.datoEspecificoConsulta.codigo !== 56 && this.state.datoEspecificoConsulta.codigo !== 66
                                                            ?  
                                                                <Grid item xs={2}>
                                                                    {this.state.datoEspecificoConsulta.anio}
                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo === 2 && this.state.datoEspecificoConsulta.codigo !== 106 && this.state.datoEspecificoConsulta.codigo !== 109
                                                            ?  
                                                                <Grid item xs={1}>
                                                                    
                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo === 35 || this.state.datoEspecificoConsulta.codigo === 28 || this.state.datoEspecificoConsulta.codigo === 46
                                                            ?
                                                                <Grid item xs={2}>

                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo === 30 || this.state.datoEspecificoConsulta.codigo === 60 || this.state.datoEspecificoConsulta.codigo === 35 || this.state.datoEspecificoConsulta.codigo === 37 || this.state.datoEspecificoConsulta.codigo === 106 || this.state.datoEspecificoConsulta.codigo === 109 || this.state.datoEspecificoConsulta.codigo === 28 || this.state.datoEspecificoConsulta.codigo === 46 || this.state.datoEspecificoConsulta.codigo === 110
                                                            ?    
                                                                <Grid item xs={2}>
                                                                    <Item>Minutos</Item>
                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo === 30 || this.state.datoEspecificoConsulta.codigo === 60 || this.state.datoEspecificoConsulta.codigo === 110 || this.state.datoEspecificoConsulta.codigo === 35 || this.state.datoEspecificoConsulta.codigo === 37 || this.state.datoEspecificoConsulta.codigo === 106 || this.state.datoEspecificoConsulta.codigo === 109 || this.state.datoEspecificoConsulta.codigo === 28 || this.state.datoEspecificoConsulta.codigo === 46
                                                            ?  
                                                                <Grid item xs={2}>
                                                                    {this.state.datoEspecificoConsulta.minutos}
                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo === 30 || this.state.datoEspecificoConsulta.codigo === 60 || this.state.datoEspecificoConsulta.codigo === 110 || this.state.datoEspecificoConsulta.codigo === 35 || this.state.datoEspecificoConsulta.codigo === 37 || this.state.datoEspecificoConsulta.codigo === 28 || this.state.datoEspecificoConsulta.codigo === 46
                                                            ?  
                                                                <Grid item xs={1}>
                                                                    
                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo === 35
                                                            ?    
                                                                <Grid item xs={2}>
                                                                    <Item>Juzgado</Item>
                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo === 10
                                                            ?
                                                                <Grid item xs={2}>
                                                                        
                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {(this.state.datoEspecificoConsulta.codigo === 5 || this.state.datoEspecificoConsulta.codigo === 52)
                                                            ?
                                                                <Grid item xs={1}>
                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {(this.state.datoEspecificoConsulta.codigo === 5 || this.state.datoEspecificoConsulta.codigo === 52)
                                                            ?
                                                                <Grid item xs={2}>
                                                                    <Item>Asignatura</Item>
                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {(this.state.datoEspecificoConsulta.codigo === 5 || this.state.datoEspecificoConsulta.codigo === 52)
                                                            ?
                                                                <Grid item xs={1}>
                                                                    {this.state.datoEspecificoConsulta.juzgado}
                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {(this.state.datoEspecificoConsulta.codigo === 5 || this.state.datoEspecificoConsulta.codigo === 52) && ((this.state.datoEspecificoConsulta.finalizado === 12) || (this.state.datoEspecificoConsulta.finalizado === 13) || (this.state.datoEspecificoConsulta.finalizado === 14) || (this.state.datoEspecificoConsulta.finalizado === 14))
                                                            ?
                                                                <Grid item xs={1}>

                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {(this.state.datoEspecificoConsulta.codigo === 5 || this.state.datoEspecificoConsulta.codigo === 52) && ((this.state.datoEspecificoConsulta.finalizado === 12) || (this.state.datoEspecificoConsulta.finalizado === 13) || (this.state.datoEspecificoConsulta.finalizado === 14) || (this.state.datoEspecificoConsulta.finalizado === 14))
                                                            ?
                                                                <Grid item xs={2}>

                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {(this.state.datoEspecificoConsulta.codigo === 5 || this.state.datoEspecificoConsulta.codigo === 52) && ((this.state.datoEspecificoConsulta.finalizado === 12) || (this.state.datoEspecificoConsulta.finalizado === 13) || (this.state.datoEspecificoConsulta.finalizado === 14) || (this.state.datoEspecificoConsulta.finalizado === 14))
                                                            ?
                                                                <Grid item xs={2}>
                                                                    <Item>Comprobante</Item>
                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {(this.state.datoEspecificoConsulta.codigo === 5 || this.state.datoEspecificoConsulta.codigo === 52) && ((this.state.datoEspecificoConsulta.finalizado === 12) || (this.state.datoEspecificoConsulta.finalizado === 13) || (this.state.datoEspecificoConsulta.finalizado === 14) || (this.state.datoEspecificoConsulta.finalizado === 14))
                                                            ?
                                                                this.state.datoEspecificoConsulta.esPDF
                                                                ?
                                                                    <Grid item xs={2}>
                                                                        <button className="btn btn-outline-primary mx-2" onClick={() => handleDownloadPdf('archivo.pdf', this.state.datoEspecificoConsulta.archivoBPS)}>Descargar</button>
                                                                    </Grid>
                                                                :
                                                                    <Grid item xs={2}>
                                                                        <button className="btn btn-outline-danger mx-2" type='button' onClick={() => this.manejarModalImagen(this.state.datoEspecificoConsulta.archivoBPS)}>Ver</button>
                                                                    </Grid>
                                                            :
                                                                null
                                                            }
                                                            {(this.state.datoEspecificoConsulta.codigo === 5 || this.state.datoEspecificoConsulta.codigo === 52) && ((this.state.datoEspecificoConsulta.finalizado === 12) || (this.state.datoEspecificoConsulta.finalizado === 13) || (this.state.datoEspecificoConsulta.finalizado === 14) || (this.state.datoEspecificoConsulta.finalizado === 18))
                                                            ?
                                                                <Grid item xs={2}>

                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo === 10
                                                            ?    
                                                                <Grid item xs={2}>
                                                                    <Item>Nueva Dirección</Item>
                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo === 35 || this.state.datoEspecificoConsulta.codigo === 10
                                                            ?  
                                                                <Grid item xs={2}>
                                                                    {this.state.datoEspecificoConsulta.juzgado}
                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo === 35 || this.state.datoEspecificoConsulta.codigo === 106 || this.state.datoEspecificoConsulta.codigo === 109
                                                            ?  
                                                                <Grid item xs={1}>
                                                                    
                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {(this.state.datoEspecificoConsulta.codigo === 30) || (this.state.datoEspecificoConsulta.codigo === 60) || this.state.datoEspecificoConsulta.codigo === 35 || this.state.datoEspecificoConsulta.codigo === 37
                                                            ?
                                                                <Grid item xs={2}>

                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo === 62
                                                            ?
                                                                <Grid item xs={2}>
                                                                    <Item>Tipo Omisión</Item>
                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo === 62
                                                            ?
                                                                <Grid item xs={2}>
                                                                    {this.state.datoEspecificoConsulta.tipo}
                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo === 30 || this.state.datoEspecificoConsulta.codigo === 60 || this.state.datoEspecificoConsulta.codigo === 35 || this.state.datoEspecificoConsulta.codigo === 37 || this.state.datoEspecificoConsulta.codigo === 28 || this.state.datoEspecificoConsulta.codigo === 46
                                                            ?    
                                                                <Grid item xs={2}>
                                                                    <Item>Tipo Salida</Item>
                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo === 30 || this.state.datoEspecificoConsulta.codigo === 60 || this.state.datoEspecificoConsulta.codigo === 35 || this.state.datoEspecificoConsulta.codigo === 28 || this.state.datoEspecificoConsulta.codigo === 46 || this.state.datoEspecificoConsulta.codigo === 37
                                                            ?  
                                                                <Grid item xs={2}>
                                                                    {this.state.datoEspecificoConsulta.tipo}
                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo === 37
                                                            ?  
                                                                <Grid item xs={2}>
                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo === 35 || this.state.datoEspecificoConsulta.codigo === 28 || this.state.datoEspecificoConsulta.codigo === 46
                                                            ?  
                                                                <Grid item xs={1}>
                                                                    
                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo === 106
                                                            ?    
                                                                <Grid item xs={2.1}>
                                                                    <Item>Entrada</Item>
                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo === 106
                                                            ?  
                                                                <Grid item xs={2}>
                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo === 106
                                                            ?  
                                                                <Grid item xs={1}>
                                                                    
                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo === 106
                                                            ?    
                                                                <Grid item xs={2.1}>
                                                                    <Item>Salilda</Item>
                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo === 106
                                                            ?  
                                                                <Grid item xs={2}>
                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo === 106
                                                            ?  
                                                                <Grid item xs={1}>
                                                                    
                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo === 106
                                                            ?    
                                                                <Grid item xs={2.1}>
                                                                    <Item>Entrada</Item>
                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo === 106
                                                            ?  
                                                                <Grid item xs={2}>
                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo === 106 || this.state.datoEspecificoConsulta.codigo === 109
                                                            ?  
                                                                <Grid item xs={1}>
                                                                    
                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo === 109
                                                            ?
                                                                <Grid item xs={2.1}>
                                                                    <Item>Concepto</Item>
                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo === 109
                                                            ?
                                                                <Grid item xs={2.1}>
                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo === 106
                                                            ?    
                                                                <Grid item xs={2.1}>
                                                                    <Item>Salilda</Item>
                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo === 106
                                                            ?  
                                                                <Grid item xs={2}>
                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo === 106 || this.state.datoEspecificoConsulta.codigo === 109
                                                            ?  
                                                                <Grid item xs={1}>
                                                                    
                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo === 110
                                                            ?
                                                                <Grid item xs={2}>
                                                                    <Item>Día</Item>
                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo === 110
                                                            ?
                                                                <Grid item xs={2}>
                                                                    {String(this.state.datoEspecificoConsulta.desde).substring(8,10) + '/' + String(this.state.datoEspecificoConsulta.desde).substring(5,7) + '/' + String(this.state.datoEspecificoConsulta.desde).substring(0,4)}
                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo === 110
                                                            ?
                                                                <Grid item xs={1}>

                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.datoEspecificoConsulta.codigo === 74
                                                            ?
                                                                <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                                                                    <Table sx={{minWidth: 700}}>
                                                                        <TableHead>
                                                                            <TableRow>
                                                                                <StyledTableCell>Lunes</StyledTableCell>
                                                                                <StyledTableCell>Martes</StyledTableCell>
                                                                                <StyledTableCell>Miercoles</StyledTableCell>
                                                                                <StyledTableCell>Jueves</StyledTableCell>
                                                                                <StyledTableCell>Viernes</StyledTableCell>
                                                                                <StyledTableCell>Sábado</StyledTableCell>
                                                                            </TableRow>
                                                                        </TableHead>
                                                                        <TableBody>
                                                                            <StyledTableRow>
                                                                                {this.state.horasEntradas.map((name) => {
                                                                                    if(this.state.datoEspecificoConsulta.entradaLunes === name.idEntrada){
                                                                                        entradaIn = name.descripcion;
                                                                                }})}
                                                                                <StyledTableCell>{entradaIn}</StyledTableCell>
                                                                                {this.state.horasEntradas.map((name) => {
                                                                                    if(this.state.datoEspecificoConsulta.entradaMartes === name.idEntrada){
                                                                                        entradaIn = name.descripcion;
                                                                                }})}
                                                                                <StyledTableCell>{entradaIn}</StyledTableCell>
                                                                                {this.state.horasEntradas.map((name) => {
                                                                                    if(this.state.datoEspecificoConsulta.entradaMiercoles === name.idEntrada){
                                                                                        entradaIn = name.descripcion;
                                                                                }})}
                                                                                <StyledTableCell>{entradaIn}</StyledTableCell>
                                                                                {this.state.horasEntradas.map((name) => {
                                                                                    if(this.state.datoEspecificoConsulta.entradaJueves === name.idEntrada){
                                                                                        entradaIn = name.descripcion;
                                                                                }})}
                                                                                <StyledTableCell>{entradaIn}</StyledTableCell>
                                                                                {this.state.horasEntradas.map((name) => {
                                                                                    if(this.state.datoEspecificoConsulta.entradaViernes === name.idEntrada){
                                                                                        entradaIn = name.descripcion;
                                                                                }})}
                                                                                <StyledTableCell>{entradaIn}</StyledTableCell>
                                                                                {this.state.horasEntradas.map((name) => {
                                                                                    if(this.state.datoEspecificoConsulta.entradaSabado === name.idEntrada){
                                                                                        entradaIn = name.descripcion;
                                                                                }})}
                                                                                <StyledTableCell>{entradaIn}</StyledTableCell>
                                                                            </StyledTableRow>
                                                                            <StyledTableRow>
                                                                                {this.state.horasEntradas.map((name) => {
                                                                                    if(this.state.datoEspecificoConsulta.salidaLunes === name.idEntrada){
                                                                                        entradaIn = name.descripcion;
                                                                                }})}
                                                                                <StyledTableCell>{entradaIn}</StyledTableCell>
                                                                                {this.state.horasEntradas.map((name) => {
                                                                                    if(this.state.datoEspecificoConsulta.salidaMartes === name.idEntrada){
                                                                                        entradaIn = name.descripcion;
                                                                                }})}
                                                                                <StyledTableCell>{entradaIn}</StyledTableCell>
                                                                                {this.state.horasEntradas.map((name) => {
                                                                                    if(this.state.datoEspecificoConsulta.salidaMiercoles === name.idEntrada){
                                                                                        entradaIn = name.descripcion;
                                                                                }})}
                                                                                <StyledTableCell>{entradaIn}</StyledTableCell>
                                                                                {this.state.horasEntradas.map((name) => {
                                                                                    if(this.state.datoEspecificoConsulta.salidaJueves === name.idEntrada){
                                                                                        entradaIn = name.descripcion;
                                                                                }})}
                                                                                <StyledTableCell>{entradaIn}</StyledTableCell>
                                                                                {this.state.horasEntradas.map((name) => {
                                                                                    if(this.state.datoEspecificoConsulta.salidaViernes === name.idEntrada){
                                                                                        entradaIn = name.descripcion;
                                                                                }})}
                                                                                <StyledTableCell>{entradaIn}</StyledTableCell>
                                                                                {this.state.horasEntradas.map((name) => {
                                                                                    if(this.state.datoEspecificoConsulta.salidaSabado === name.idEntrada){
                                                                                        entradaIn = name.descripcion;
                                                                                }})}
                                                                                <StyledTableCell>{entradaIn}</StyledTableCell>
                                                                            </StyledTableRow>
                                                                            <StyledTableRow>
                                                                                <StyledTableCell></StyledTableCell>
                                                                                <StyledTableCell></StyledTableCell>
                                                                                <StyledTableCell>Desde</StyledTableCell>
                                                                                <StyledTableCell>{String(this.state.datoEspecificoConsulta.desde).substring(8,10) + '/' + String(this.state.datoEspecificoConsulta.desde).substring(5,7) + '/' + String(this.state.datoEspecificoConsulta.desde).substring(0,4)}</StyledTableCell>
                                                                                <StyledTableCell></StyledTableCell>
                                                                                <StyledTableCell></StyledTableCell>
                                                                            </StyledTableRow>
                                                                        </TableBody>
                                                                    </Table>
                                                                </TableContainer>
                                                            :
                                                                null
                                                            }
                                                        </Grid>
                                                    </Box>
                                                    <br/>
                                                    {this.state.datoEspecificoConsulta.codigo === 110 || this.state.datoEspecificoConsulta.codigo === 61 || this.state.datoEspecificoConsulta.codigo === 37 || this.state.datoEspecificoConsulta.codigo === 77 || this.state.datoEspecificoConsulta.codigo === 60 ? <textarea style={{width:"100%", border:"2px solid #D6EAF8"}} rows={10} cols={40} id='comentarios' value={this.state.datoEspecificoConsulta.comentarios} disabled/> : null}
                                                    {this.state.datoEspecificoConsulta.motivoRechazo !== null && this.state.datoEspecificoConsulta.motivoRechazo !== '' ? <textarea style={{width:"100%", border:"2px solid #D6EAF8"}} rows={10} cols={40} id='motivoRechazo' value={this.state.datoEspecificoConsulta.motivoRechazo} disabled/> : null}
                                                    <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.cerrarModal}>Volver</button>
                                                </Container>

                                            :
                                                null
                                            }
                                        </>
                                    }
                                </>
                            :
                                null
                            }
                        
                    </Container>
                :
                    <Redirect to='/login'/>
                }
            </>
        )//Final return
    }//Final render

    manejarCambiosDatos(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState({
            errores: null,
            notificaciones: null,
        });
        this.setState(state => {
            const numFunActualizado = state.busqueda;
            numFunActualizado[clave] = valor;
            
            return{
                busqueda: numFunActualizado,
            };
        });
    }

    manejarAtras(e){
        e.preventDefault();
        const fech = new Date();
        this.setState({
            consulta: false,
            consultaRealizada: [],
            errores: null,
            notificaciones: null,
            atras: false,
            busqueda: {
                codigo: 1001,
                numeroFuncionario: sessionStorage.numeroFuncionario,
                numeroFuncionarioBusqueda: sessionStorage.numeroFuncionario,
                nombreFuncionarioBusqueda: sessionStorage.nombreFuncionario,
                ubicacionBusqueda: '',
                ubicacionCentral: '',
                mes: '',
                anio: '',
            },
        });
    }

    manejarAtrasPagina(e){
        e.preventDefault();
        this.setState({
            atras: true,
            errores: null,
            notificaciones: null,
        })
    }

    async manejoEnvioConsulta(e){
        e.preventDefault();
        this.setState({
            errores: null,
            notificaciones: null,
            atras: false,
        });
        if(this.state.busqueda.mes === ''){
            this.setState({
                errores: 'DEBE SELECCIONAR UN MES!',
            });
        }else if((this.state.busqueda.anio === '')){
            this.setState({
                errores: 'DEBE INGRESAR EL AÑO!',
            });
        }else{
            this.setState({
                errores: null,
                notificaciones: null,
                loading: true,
            })
            const cargaUtil = JSON.stringify([this.state.busqueda, sessionStorage.numeroFuncionario, sessionStorage.numeroFuncionarioAsociado]);

            const respuesta = await fetch(`${Constantes.RUTA_API}/obtener_controlAsistencia.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const exito = await respuesta.json();

            this.setState({
                errores: exito[0],
                loading: false,
            })
            let num = '';
            if(exito[0] === 'ok'){
                this.setState({
                    consultaRealizada: exito[1],
                    errores: null,
                    notificaciones: null,
                    consulta: true,
                    numerosFuncionariosConsulta: exito[2],
                    mesActual: exito[3],
                });

                if((this.state.busqueda.codigo === '1000') && (this.state.busqueda.numeroFuncionarioBusqueda !== '') && (this.state.busqueda.ubicacionBusqueda === '')){
                    this.setState({
                        tipoEncabezado: 'LISTADO DE MARCAS FUNCIONARIO ' + this.state.busqueda.numeroFuncionarioBusqueda,
                    });
                }
            }else{
                const fech = new Date();
                this.setState({
                    consultaRealizada: [],
                    /*errores: 'No hay datos para la consulta realizada!',*/
                    notificaciones: null,
                    consulta: false,
                    busqueda: {
                        codigo: 1001,
                        numeroFuncionario: sessionStorage.numeroFuncionario,
                        numeroFuncionarioBusqueda: sessionStorage.numeroFuncionario,
                        nombreFuncionarioBusqueda: sessionStorage.nombreFuncionario,
                        ubicacionBusqueda: '',
                        ubicacionCentral: '',
                        mes: '',
                        anio: '',
                    },
                });
            }
        }
    }

    async toggleFieldset(e) {
        if(this.state.isFieldsetOpen){
            this.setState({
                isFieldsetOpen: false,
                errores: null,
                notificaciones: null,
            })
        }else{
            this.setState({
                isFieldsetOpen: true,
                errores: null,
                notificaciones: null,
            })
        }
    };

    manejarConsulta(dato){
        this.setState({
            modalConsulta: true,
            datoEspecificoConsulta: dato,
            errores: null,
            notificaciones: null,
        })
    }

    async handleDateClick(dato) {
        // Redirigir a una nueva ventana con la URL deseada
        //window.open(`/details?date=${date}`, '_blank');
        this.setState({
            consultaEspecifica: true,
            datoEspecifico: dato,
            loading: true,
            errores: null,
            notificaciones: null,
        })
        //Consulto la info de ese día
        const cargaUtil = JSON.stringify([dato]);

        const respuesta = await fetch(`${Constantes.RUTA_API}/obtener_obtenerAccionesDia.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const exito = await respuesta.json();

        this.setState({
            loading: false,
        })
        if(exito[0] === 'ok'){
            this.setState({
                informesAListar: exito[1],
                hayDatos: true,
                tieneSolLt: exito[2],
                tieneSolSAH: exito[3],
                tieneSolDia: exito[4],
            })
        }
    };

    manejarNuevaSolicitud(e){
        e.preventDefault();
        this.setState({
            nuevaSolicitud: true,
        })
    }

    manejarAtrasEspecifico(e){
        e.preventDefault();
        this.setState({
            datoEspecifico: {},
            consultaEspecifica: false,
            nuevaSolicitud: false,
            hayDatos: false,
            informesAListar: [],
            tieneSolLt: false,
            tieneSolSAH: false,
            tieneSolDia: false,
        })
    }

    cerrarModal(e){
        e.preventDefault();
        this.setState({
            modalConsulta: false,
            datoEspecificoConsulta: {},
        })
    }

    compensar(dato, tipo){
        this.setState({
            compensarLlegadaTarde: true,
            datosAEnviar: {
                numeroFuncionario: dato.numeroFuncionario,
                codigo: '',
                nombreFuncionario: dato.nombreFuncionario,
                ubicacionBusqueda: '',
                ubicacionCentral: '',
                desde: dato.fechaParaInfo,
                hasta: dato.fechaParaInfo,
                anio: '',
                dias: '',
                marca1: '',
                marca2: '',
                minutos: '',
                tipoMov: '2',
                familiar: '',
                archivo: '',
                archivoFamiliar: '',
                juzgado: '',
                entrada: '',
                salida: '',
                entrada2: '',
                salida2: '',
                salidaAntHoraDesde: '',
                salidaAntHoraHasta: '',
                concepto: '',
                tipo: tipo,
                entradaLunes: '',
                entradaMartes: '',
                entradaMiercoles: '',
                entradaJueves: '',
                entradaViernes: '',
                entradaSabado: '',
                salidaLunes: '',
                salidaMartes: '',
                salidaMiercoles: '',
                salidaJueves: '',
                salidaViernes: '',
                salidaSabado: '',
                comentarios: '',
            }
        })
    }
    

    manejarCambioAEnviar(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState({
            errores: null,
            notificaciones: null,
        });
        this.setState(state => {
            const numFunActualizado = state.datosAEnviar;
            numFunActualizado[clave] = valor;
            
            return{
                datosAEnviar: numFunActualizado,
            };
        });
    }

    async manejarEnvioInforme(e){
        e.preventDefault();

        if((this.state.datosAEnviar.codigo === '')){
            this.setState({
                notificaciones: null,
                errores: 'Debe indicar un concepto!',
            })
        }else{
            this.setState({
                errores: null,
                notificaciones: null,
                loading: true,
            })
            const cargaUtil = JSON.stringify([this.state.datosAEnviar, 0, false]);

            const control = await fetch(`${Constantes.RUTA_API}/contrlar_movimiento.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const exito = await control.json();

            this.setState({
                errores: exito,
                loading: false,
            })
            let num = '';
            if(exito === 'ok'){
                this.setState({
                    errores: null,
                    consultaEspecifica: false,
                    notificaciones: 'Los datos fueron ingresados correctamente!',
                    datoEspecifico: {},
                    nuevaSolicitud: false,
                    compensarLlegadaTarde: false,
                    datosAEnviar: {
                        numeroFuncionario: '',
                        codigo: '',
                        nombreFuncionario: '',
                        ubicacionBusqueda: '',
                        ubicacionCentral: '',
                        desde: '',
                        hasta: '',
                        anio: '',
                        dias: '',
                        marca1: '',
                        marca2: '',
                        minutos: '',
                        tipoMov: '2',
                        familiar: '',
                        archivo: '',
                        archivoFamiliar: '',
                        juzgado: '',
                        entrada: '',
                        salida: '',
                        entrada2: '',
                        salida2: '',
                        salidaAntHoraDesde: '',
                        salidaAntHoraHasta: '',
                        concepto: '',
                        tipo: '',
                        entradaLunes: '',
                        entradaMartes: '',
                        entradaMiercoles: '',
                        entradaJueves: '',
                        entradaViernes: '',
                        entradaSabado: '',
                        salidaLunes: '',
                        salidaMartes: '',
                        salidaMiercoles: '',
                        salidaJueves: '',
                        salidaViernes: '',
                        salidaSabado: '',
                        comentarios: '',
                    },
                })
            }
        }
        
    }
}

export default ConsultasControlAsistenciaUsuario